import React from 'react';
import { CheckCircleIcon, XCircleIcon } from 'lucide-react';
export function CoreBeliefs() {
  const beliefs = [{
    title: 'Recruiting is a Factory, Not a Casino.',
    description: 'Stop treating hiring like a gamble. It should be structured, predictable, and measurable.',
    points: ['Structured', 'Predictable', 'Measurable', 'Repeatable'],
    closing: 'A good system removes the stress.'
  }, {
    title: 'Retention Starts Before Day One.',
    description: "Reps don't quit because the job is hard. They quit because they are confused. You recruit the curious and develop the committed.",
    points: ['The first 8 weeks matter most', 'Structure beats motivation', 'Culture must be designed, not assumed'],
    closing: 'We fix the clarity, so you keep the rep.'
  }, {
    title: 'Partners, Not Vendors.',
    description: "We don't just send you leads. We help you install the machine into your business.",
    points: ['Strategy matters', 'Feedback matters', 'Leadership matters', 'Consistency matters'],
    closing: 'We work with you.'
  }];
  const whatWeDont = ['We don\'t sell "magic bullets."', "We don't promise results we can't control.", "We don't work with leaders who refuse to change.", "We don't treat this like a short-term gig."];
  return <section className="section-padding bg-gray-50" data-id="element-131">
      <div className="container-custom" data-id="element-132">
        <div className="max-w-4xl mx-auto text-center mb-16" data-id="element-133">
          <h2 className="mb-6" data-id="element-134">How We Think</h2>
          <p className="text-body-large leading-relaxed" data-id="element-135">
            These are the rules we operate by.
          </p>
        </div>

        {/* Beliefs */}
        <div className="max-w-5xl mx-auto space-y-8 mb-16" data-id="element-136">
          {beliefs.map((belief, index) => <div key={index} className="bg-white rounded-xl p-8 shadow-lg border-l-4 border-slate" data-id="element-137">
              <h3 className="mb-4" data-id="element-138">{belief.title}</h3>
              <p className="leading-relaxed mb-4" data-id="element-139">{belief.description}</p>
              <div className="bg-gray-50 rounded-lg p-6 mb-4" data-id="element-140">
                <ul className="space-y-2" data-id="element-141">
                  {belief.points.map((point, idx) => <li key={idx} className="flex items-center" data-id="element-142">
                      <CheckCircleIcon className="h-5 w-5 text-slate flex-shrink-0 mr-3" data-id="element-143" />
                      {point}
                    </li>)}
                </ul>
              </div>
              <p className="italic" data-id="element-144">{belief.closing}</p>
            </div>)}
        </div>

        {/* What We Don't Do */}
        <div className="max-w-4xl mx-auto" data-id="element-145">
          <h3 className="text-center mb-8" data-id="element-146">What We Don't Do</h3>
          <div className="bg-white rounded-xl p-8 shadow-lg border-2 border-gray-200" data-id="element-147">
            <ul className="space-y-4" data-id="element-148">
              {whatWeDont.map((item, index) => <li key={index} className="flex items-start" data-id="element-149">
                  <XCircleIcon className="h-6 w-6 text-gray-400 flex-shrink-0 mr-3 mt-1" data-id="element-150" />
                  <span data-id="element-151">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}